import React from 'react';

import { ConfigContext } from './context';

const ConfigConsumer = props => (
  <ConfigContext.Consumer>{context => props.children(context)}</ConfigContext.Consumer>
);

export default ConfigConsumer;
